(function() {
'use strict';

angular
    .module('TR')
    .service('FilterIdUtils', FilterIdUtils);

function FilterIdUtils(
    $http,
    $location,
    currentDestination,
    pageStrand) {
    const url = '/api2/destination/filters/';
    const service = {
        estabGroupFilterAvailable,
        createEstabGroupOptions,
        lookupFid,
        sanitiseFidFilters,
        updateEstabGroupProperties,
        getFilters
    };
    let _filterData;


    const fidSettings = {
        ignorable: ['EstabGroupIds', 'EstabGroupIds', 'EstabGroupName', 'EstablishmentName', 'FilterByEstabGroup'],
        propertyMap: {
            BoardTypes: 'HotelsByBoardType',
            FacilityCodes: 'MergedHotelsByFacility',
            PriceRange: 'PriceRange',
            HolidayPriceRange: 'HolidayPriceRange',
            RatingRange: 'RatingRange',
            PropertyTypes: 'HotelsByPropertyType',
            Stars: 'HotelsByStar'
        }
    };

    function _groupFilterAvailable(filter) {
        return filter != null && filter.EstabGroupName != null && filter.EstabGroupName !== '';
    }

    function lookupFid(fid) {
        return currentDestination
            .getCurrentDestination()
            .then(dest => getFilters(fid, pageStrand.fromRoute(dest)));
    }

    function getFilters(fid, pageStrandId) {
        const params = {
            DomainId: TRPCONFIG.Domain.DomainId,
            FilterId: parseInt(fid),
            PageStrandId: pageStrandId
        };
        const opt = {
            cache: true,
            customErrCallback: {
                404: () => true
            }
        };
        return $http.get(`${url}get?${jQuery.param(params)}`, opt)
            .then(
                res => {
                    const filters = _.pickBy(res.data, v => v !== null);
                    // renaming keys
                    if (filters.BoardTypeCode) { filters.BoardTypes = filters.BoardTypeCode; }
                    if (filters.PropertyType) { filters.PropertyTypes = filters.PropertyType; }

                    // filter by estab group
                    filters.FilterByEstabGroup = filters.EstabGroupIds &&
                        filters.EstabGroupIds.length > 0 &&
                        filters.EstabGroupName != null;
                    _filterData = filters;
                    return filters;
                },
                () => null
            );
    }

    //this needs to work off the original definition of the fidFilter, *not* the current
    //filter as it is at the moment because the current filter can have the estabgroupIds
    //removed by unchecking the checkbox whereupon it all goes wrong.
    function createEstabGroupOptions(groupAggregates) {
        if (_groupFilterAvailable(_filterData) && groupAggregates) {
            let hotelCount = 0;
            for (let i = 0; i < _filterData.EstabGroupIds.length; i++) {
                const group = groupAggregates[_filterData.EstabGroupIds[i]];
                if (_.isObject(group)) {
                    hotelCount = group.Count || 0;
                } else {
                    hotelCount += group || 0;
                }
            }

            return [{
                title: _filterData.EstabGroupName,
                count: hotelCount
            }];
        }

        return null;
    }

    function estabGroupFilterAvailable(filter) {
        return _groupFilterAvailable(filter);
    }

    function updateEstabGroupProperties(filter) {
        //we need to correctly set the estab group ids property based on the bool FilterByEstabGroup
        //and ensure the groupname is always set

        if (!filter.EstabGroupName && _filterData && _filterData.EstabGroupName) {
            filter.EstabGroupName = _filterData.EstabGroupName;
        }

        //1. if it is true don't remove the groupIds (might have to add ids in)
        //2. otherwise clear it
        if (filter.FilterByEstabGroup === true) {
            if (filter.EstabGroupIds.length === 0 && _filterData) {
                filter.EstabGroupIds = angular.copy(_filterData.EstabGroupIds);
            }
        } else {
            filter.EstabGroupIds = [];
        }
    }

    function sanitiseFidFilters(f, agg, defaultFilterCriteria) {
        const { propertyMap } = fidSettings;

        function relevantFilters(f) {
            f = _.omit(f, fidSettings.ignorable);
            return _.omitBy(f, (p, key) => !p || _.isArray(p) && !p.length || _.isEmpty(agg[propertyMap[key]]));
        }

        function arrayTypeFilter(key) {
            return x => _.isObject(agg[propertyMap[key]][x]) ? !_.isEmpty(agg[propertyMap[key]][x])
                : agg[propertyMap[key]][x] != null;
        }

        function objectFilter(filterValue, key) {
            if (agg[propertyMap[key]].Min > filterValue.Min) {
                filterValue.Min = agg[propertyMap[key]].Min;
            }
            if (agg[propertyMap[key]].Max < filterValue.Max) {
                filterValue.Max = agg[propertyMap[key]].Max;
            }
            return filterValue;
        }

        function compareFiltersWithAggregates(filterValue, key) {
            return _.isArray(filterValue) ? filterValue.filter(arrayTypeFilter(key))
                : _.isObject(filterValue) && filterValue.Min != null && filterValue.Max ? objectFilter(filterValue, key)
                    : filterValue;
        }

        function filteredCriteria() {
            return _.mapValues(relevantFilters(f), compareFiltersWithAggregates);
        }

        const filteredFilter = angular.extend(defaultFilterCriteria, filteredCriteria());
        return angular.equals(filteredFilter, f) ? false : filteredFilter;
    }


    return service;
}
})();
